import { connect } from "react-redux";
import { NavLink } from "react-router-dom"; // Use the appropriate router package for your application
import { useSelector } from "react-redux";
import { Box, Text, VStack } from "@chakra-ui/react";

import { navLinks } from "../../store/constants";

function Nav() {
  const { reportRange } = useSelector((state) => state.defaultReducer);

  return (
    <Box className="navigation">
      <VStack spacing={4} align="stretch" pt={0}>
        {navLinks
          .find((a) => a.name === reportRange)
          ?.links.map((a, i) => {
            return (
              <Box key={i} mt="10px">
                <Text fontSize="14px" fontWeight="400" color="var(--gray-8)">
                  {a.name}
                </Text>
                <VStack spacing={2} align="stretch" pt={2}>
                  {a.links.map((b, j) => {
                    return (
                      <NavLink
                        color="#fff"
                        key={j}
                        to={b.link}
                        className={({ isActive }) => isActive ? "active" : ""}
                      >
                        {b.name}
                      </NavLink>
                    );
                  })}
                </VStack>
              </Box>
            );
          })}
      </VStack>
    </Box>
  );
}

export default connect(null, null)(Nav);
